/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file Column component for displaying a number value.
 * @author Heino Lenting

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "../column-base/column-base.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./column-number.component";
import * as i3 from "../../column-provider";
var styles_ColumnNumberComponent = [i0.styles];
var RenderType_ColumnNumberComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_ColumnNumberComponent, data: {} });
export { RenderType_ColumnNumberComponent as RenderType_ColumnNumberComponent };
export function View_ColumnNumberComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "div", [["class", "sym-column-editor text-truncate sym-column-number"]], null, null, null, null, null)), (_l()(), i1.ɵted(1, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.provider.value; _ck(_v, 1, 0, currVal_0); }); }
export function View_ColumnNumberComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "sym-column-number", [], null, null, null, View_ColumnNumberComponent_0, RenderType_ColumnNumberComponent)), i1.ɵdid(1, 4374528, null, 0, i2.ColumnNumberComponent, [i3.ColumnProvider, i1.ChangeDetectorRef], null, null)], null, null); }
var ColumnNumberComponentNgFactory = i1.ɵccf("sym-column-number", i2.ColumnNumberComponent, View_ColumnNumberComponent_Host_0, {}, {}, []);
export { ColumnNumberComponentNgFactory as ColumnNumberComponentNgFactory };
